{{ this.utcTimeData ? (this.utcTimeData | amLocal | amLocale:'en-gb' | amDateFormat: preferredDateFormat) : '' }}
